export class Email{

  cliente: string;
  destinatarios: string[];
  codigoAeroplanta: string;
  tipoNotificacion: string;
  fechaHoraEnvio:Date;

}
